import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    items: [],
    size: '',
    units: ''
  },
  getters: {
    sizeFilterOptions: state => {
      const options = []
      state.items.forEach(item => {
        if (item.odu_downloads_size !== 'NULL' && item.odu_downloads_size !== 0 && options.indexOf(item.odu_downloads_size) === -1) options.push(item.odu_downloads_size)
      })
      return options
    },
    unitFilterOptions: state => {
      const options = []
      state.items.forEach(item => {
        if (item.odu_downloads_units !== 'NULL' && item.odu_downloads_units !== 0 && options.indexOf(item.odu_downloads_units) === -1) options.push(item.odu_downloads_units)
      })
      return options
    },
    filteredItems: (state) => {
      let items = state.items
      if (state.size) items = items.filter(item => item.odu_downloads_size === state.size)
      if (state.units) items = items.filter(item => item.odu_downloads_units === state.units)
      return items
    }
  },
  mutations: {
    setItems (state, payload) {
      state.items = payload
    },
    setSize (state, payload) {
      state.size = payload
    },
    setUnits (state, payload) {
      state.units = payload
    }
  },
  actions: {
    async init ({ dispatch }) {
      dispatch('getItems', window.app.cad_list.pageUid ?? 0)
    },
    async getItems ({ commit }, pageUid) {
      await axios
        .get(window.app.cad_list.data)
        .then(response => {
          commit('setItems', response.data.filter(item => !pageUid || item.pid === parseInt(pageUid)))
        })
    }
  }
})
